import { useState } from "react";

function App() {
  const [array, setArray] = useState([
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
  ]);

  const [buttons, setButtons] = useState([0, 0, 0, 0, 0, 0]);

  const [player, setPlayer] = useState(false);

  const [finished, setFinished] = useState(false);

  const changeButtonValue = (index) => {
    changeColor(index, buttons[index]);
    buttons[index] = buttons[index] + 1;
  };

  const winner = () => {
    setFinished(false);
    setArray([
      ["", "", "", "", "", ""],
      ["", "", "", "", "", ""],
      ["", "", "", "", "", ""],
      ["", "", "", "", "", ""],
      ["", "", "", "", "", ""],
    ]);
    setButtons([0, 0, 0, 0, 0, 0]);
    setPlayer(false);
  };

  const changeColor = (index, item) => {
    array[item][index] = player ? "bg-blue-700" : "bg-red-700";
    setPlayer(!player);
    //check winner in rows line
    if (index === 0) {
      if (
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1]
      ) {
        setFinished(true);
      }
    } else if (index === 5) {
      if (
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 1]
      ) {
        setFinished(true);
      }
    } else {
      if (
        array[item][index] === array[item][index + 1] &&
        array[item][index] === array[item][index - 1]
      ) {
        setFinished(true);
      } else if (
        array[item][index] === array[item][index - 2] &&
        array[item][index] === array[item][index - 1]
      ) {
        setFinished(true);
      } else if (
        array[item][index] === array[item][index + 2] &&
        array[item][index] === array[item][index + 1]
      ) {
        setFinished(true);
      } else {
      }
    }
    //check winner in columns line
    if (item >= 2) {
      if (
        array[item][index] === array[item - 2][index] &&
        array[item][index] === array[item - 1][index]
      ) {
        setFinished(true);
      }
    }
    //check winner in x lines
    //from left to right
    if (
      item > 0 &&
      item < 4 &&
      array[item][index] === array[item - 1][index - 1] &&
      array[item][index] === array[item + 1][index + 1]
    ) {
      setFinished(true);
    }
    if (
      item >= 2 &&
      array[item][index] === array[item - 1][index - 1] &&
      array[item][index] === array[item - 2][index - 2]
    ) {
      setFinished(true);
    }
    if (
      item <= 2 &&
      array[item][index] === array[item + 1][index + 1] &&
      array[item][index] === array[item + 2][index + 2]
    ) {
      setFinished(true);
    }

    // from right to left
    if (
      item > 0 &&
      item < 4 &&
      array[item][index] === array[item - 1][index + 1] &&
      array[item][index] === array[item + 1][index - 1]
    ) {
      setFinished(true);
    }
    if (
      item >= 2 &&
      array[item][index] === array[item - 1][index + 1] &&
      array[item][index] === array[item - 2][index + 2]
    ) {
      setFinished(true);
    }
    if (
      item <= 2 &&
      array[item][index] === array[item + 1][index - 1] &&
      array[item][index] === array[item + 2][index - 2]
    ) {
      setFinished(true);
    }
  };

  return (
    <div className="w-full min-h-screen flex flex-col items-center px-4 pt-20 justify-start">
      <div className="w-full md:w-1/2 grid grid-cols-6">
        {buttons.map((item, index) => (
          <button
            key={index}
            type="button"
            onClick={() => changeButtonValue(index)}
            disabled={item >= 5}
            className={`w-full flex items-center justify-center py-4 md:py-12${
              item < 5 ? " md:hover:animate-bounce" : ""
            }`}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.0001 3.67157L13.0001 3.67157L13.0001 16.4999L16.2426 13.2574L17.6568 14.6716L12 20.3284L6.34314 14.6716L7.75735 13.2574L11.0001 16.5001L11.0001 3.67157Z"
                fill={item < 5 ? (player ? "#1d4ed8" : "#b91c1c") : "#fff"}
              />
            </svg>
          </button>
        ))}
      </div>
      <div
        className={`${
          player ? "border-blue-700 " : "border-red-700 "
        } w-full md:w-1/2 h-full flex flex-col-reverse border-b-2 border-x-2`}
      >
        {array.map((item, index) => (
          <div
            key={index}
            className={`${
              player
                ? "border-blue-700 divide-blue-700"
                : "border-red-700 divide-red-700"
            } w-full grid grid-cols-6 divide-x-2 border-t-2`}
          >
            {item.map((item2, index) => (
              <div
                key={index}
                className="w-full flex items-center justify-center p-1 md:p-2"
              >
                <div
                  className={` ${item2} w-12 md:w-24 h-12 md:h-24 rounded-full`}
                ></div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="w-full flex justify-between px-0 md:px-32 pt-8 md:pt-24">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-20 w-20 border rounded-full p-2 ${
            player ? "border-transparent" : "border-red-700"
          }`}
          viewBox="0 0 20 20"
          fill={player ? "currentColor" : "#b91c1c"}
        >
          <path
            fillRule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clipRule="evenodd"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-20 w-20 border rounded-full p-2 ${
            player ? "border-blue-700" : "border-transparent"
          }`}
          viewBox="0 0 20 20"
          fill={player ? "#1d4ed8" : "currentColor"}
        >
          <path
            fillRule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div
        className={`absolute ${
          finished ? "block" : "hidden"
        } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
      >
        <div className="w-full md:w-1/3 flex flex-col items-center justify-center bg-white rounded-xl p-16 ">
          <p>Loja mbaroj!</p>
          <p>
            Fitues i lojës ishe lojtari me ngjyrë të
            <span
              className={`${
                !player ? "text-blue-700" : "text-red-700"
              } font-bold`}
            >
              {!player ? " kaltër" : " kuqe"}
            </span>
            .
          </p>
          <button
            className="border rounded-lg px-4 py-2 text-lg mt-4 hover:bg-gray-100"
            onClick={() => winner()}
          >
            Luaj përsëri
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
